import { supabase } from "@/integrations/supabase/client";

export type SuperadminAuditAction =
  | "company_created"
  | "company_deleted"
  | "company_renamed"
  | "admin_assigned"
  | "superadmin_granted"
  | "superadmin_revoked"
  | "user_deleted"
  | "tenant_switched"
  | "work_order_deleted";


interface LogParams {
  action: SuperadminAuditAction;
  targetCompany?: { id: string; name: string } | null;
  targetUser?: { id?: string | null; email?: string | null } | null;
  metadata?: Record<string, unknown>;
}

/**
 * Append an entry to the superadmin audit log. Best-effort: failures are
 * logged to the console but never block the primary operation.
 */
export async function logSuperadminAction(params: LogParams): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { error } = await supabase.from("superadmin_audit_log").insert([{
      actor_user_id: user.id,
      actor_email: user.email ?? null,
      action: params.action,
      target_company_id: params.targetCompany?.id ?? null,
      target_company_name: params.targetCompany?.name ?? null,
      target_user_id: params.targetUser?.id ?? null,
      target_user_email: params.targetUser?.email ?? null,
      metadata: (params.metadata ?? {}) as never,
    }]);
    if (error) console.warn("[superadmin-audit] insert failed", error);
  } catch (err) {
    console.warn("[superadmin-audit] unexpected error", err);
  }
}
